module.exports = __webpack_public_path__ + "img/s20-40.c574240d.png";